import React from 'react';
import createReactClass from 'create-react-class';

var Widget = createReactClass({
  getDefaultProps(){
    return {
      title: 'Title',
      icon: 'cubes',
      containerClassName: 'col-md-12',
      bodyClassName: ''
    };
  },

  render() {
    return (
      <article className={this.props.containerClassName}>
        <div className="jarviswidget jarviswidget-color-blue">
          <header>
            <span className="widget-icon"> <i className={`fa fa-${this.props.icon}`}></i> </span>
            <h2>{this.props.title}</h2>
          </header>
          <div>
            <div className={`widget-body no-padding widget-hide-overflow ${this.props.bodyClassName}`}>
              {this.props.children}
            </div>
          </div>
        </div>
      </article>
    );
  }
});

export default Widget;



// WEBPACK FOOTER //
// ./src/components/common/Widget.js